export default function Stats() {
  const stats = [
    {
      icon: 'ri-shopping-cart-line',
      value: '$2.5B+',
      label: 'Transaction Volume',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-user-line',
      value: '5M+',
      label: 'Happy Customers',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-global-line',
      value: '150+',
      label: 'Countries Served',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: 'ri-time-line',
      value: '24/7',
      label: 'AI Support',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className={`w-16 h-16 mx-auto mb-4 bg-gradient-to-br ${stat.color} rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform`}>
                <i className={`${stat.icon} text-white text-2xl`}></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
